module.exports = __webpack_public_path__ + "static/assign-shifts-2f9ac3990879f0fdc7282efca367d119.png";